import { render } from "./DeviceIncompatibilityModal.vue?vue&type=template&id=50e90326&scoped=true"
import script from "./DeviceIncompatibilityModal.vue?vue&type=script&lang=js"
export * from "./DeviceIncompatibilityModal.vue?vue&type=script&lang=js"

import "./DeviceIncompatibilityModal.vue?vue&type=style&index=0&id=50e90326&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e90326"]])

export default __exports__